import { $lists } from "@/services";
const { getListStats } = $lists;

/**
 * Integration detail drawer common functions and attributes
 * @description Add the common redundant code in this mixin
 * @author {Jatin Kamboj}
 */
export default {
  name: "IntegrationDetailMixin",
  /**
|--------------------------------------------------
| Data properties
|--------------------------------------------------
*/
  data() {
    return {
      isListLoading: false,
      listDetails: {}
    };
  },
  computed: {
    hasCrmId() {
      return !!this.$store.getters["ui/drawer"].right.crm_id;
    }
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    /**
     * Fetches details of a list
     * @param list_id Id of the list whose details are to be fetched
     */
    async getListDetails({ list_id }) {
      try {
        if (!list_id) return;
        this.isListLoading = true;
        const { data } = await getListStats(list_id);
        this.listDetails = data || {};
      } catch (error) {
        this.$store.commit("ui/snackbar", {
          message: error.message,
          type: "warning"
        });
      } finally {
        this.isListLoading = false;
      }
    }
  }
};
